import { render, staticRenderFns } from "./SideTile.vue?vue&type=template&id=d3ce9b04&scoped=true"
import script from "./SideTile.vue?vue&type=script&lang=ts"
export * from "./SideTile.vue?vue&type=script&lang=ts"
import style0 from "./SideTile.vue?vue&type=style&index=0&id=d3ce9b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ce9b04",
  null
  
)

export default component.exports